import { useSyncExternalStore } from "react";

import { getSession, subscribe, type SessionState } from "@/api/session";

/** The current sign-in state; re-renders on sign-in/out. */
export function useSession(): SessionState {
  return useSyncExternalStore(subscribe, getSession, getSession);
}
